import { HttpTypes } from "@medusajs/types"

type ProductLike =
  | (Pick<HttpTypes.StoreProduct, "title"> & {
      metadata?: Record<string, unknown> | null
    })
  | null
  | undefined

/**
 * Customer-facing product name = the clean Odoo "Online Title"
 * (`metadata.display_name`, e.g. "Superior Embroidered Panjabi"), falling back
 * to the Odoo18 internal title (`product.title`, "Tier Type - Code") when no
 * display name is set.
 *
 * Naming decision (2026-06-30, supersedes the 2026-06-20 retirement): the
 * descriptor name is colour-free and code-free and lives in Odoo `medusa_title`
 * → pushed to `metadata.display_name` by `build_product_metadata`. The
 * storefront (PDP H1, cards, breadcrumb leaf, image alt, JSON-LD Product.name)
 * and the Facebook feed show it; the style code shows separately as "Style №".
 * `product.title` is UNCHANGED (it stays the Odoo↔Medusa match key). Products
 * with no display name simply fall back to their Medusa title.
 */
export function getDisplayTitle(product: ProductLike): string {
  const displayName = product?.metadata?.["display_name"]
  if (typeof displayName === "string" && displayName.trim()) {
    return displayName.trim()
  }
  return product?.title || ""
}

/** Main colour authored in Odoo (`metadata.color`), if any. */
export function getDisplayColor(product: ProductLike): string | undefined {
  const value = product?.metadata?.["color"]
  return typeof value === "string" && value.trim() ? value.trim() : undefined
}
